// client/src/components/Admin/Dashboard/_shared/SectionHeader.js
//
// M06 Fase 4 - Cabecera estandar de seccion vertical del dashboard.
// El `id` se usa como ancla para el nav lateral (Fase 7).

import React from "react";
import styles from "./SectionHeader.module.scss";

export function SectionHeader({ id, title, subtitle }) {
  return (
    <div id={id} className={styles.sectionHeader}>
      <div className={styles.titleBlock}>
        <h2 className={styles.title}>{title}</h2>
        {subtitle ? <div className={styles.subtitle}>{subtitle}</div> : null}
      </div>
    </div>
  );
}
